import { BILoggerProvider } from '@wix/fe-essentials/react';
import React, { FC, ReactNode, useMemo } from 'react';
import { createBiLogger } from '../../essentials/bi';
import {
  getEditorSessionId,
  getEditorSubType,
  getMetaSiteId,
  getUserId,
} from '../../utils';

const BI_PLATFORM_HOST_INTEGRATION_SRC = 164;

interface Props {
  src?: number;
  endpoint?: string;
  children?: ReactNode;
}

/**
 * Use hook
 * ```
 * import { useBILogger } from '@wix/fe-essentials/react';
 * ```
 * in order to access the logger instance.
 */
export const EditorPlatformBIProvider: FC<Props> = ({
  children,
  endpoint,
  src = BI_PLATFORM_HOST_INTEGRATION_SRC,
}) => {
  const userId = getUserId() || 'EMPTY_USER_ID';
  const metaSiteId = getMetaSiteId();
  const editorSessionId = getEditorSessionId() || '';
  const editorType = getEditorSubType();

  const logger = useMemo(() => {
    return createBiLogger({
      userId,
      editorSessionId,
      metaSiteId,
      editorType: editorType || 'EMPTY_EDITOR_TYPE',
      endpoint,
      src,
    });
  }, [userId, editorSessionId, metaSiteId, editorType, endpoint, src]);

  return <BILoggerProvider value={logger}>{children}</BILoggerProvider>;
};
